




















import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import FooterButton from '@/components/popup/btt/FooterButton.vue'

@Component({
  components: {BttPopup, FooterButton},
})
export default class PopbillCertRegistrationPopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: true, type: Boolean}) allowClose: boolean

  open: boolean = true

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }

  onClickRegistration() {
    this.$emit('register', 'popbill')
    this.onHandlePopup(false)
  }
}
